import * as joda from "@js-joda/core";
import { checkAllCasesHandled } from "trader.ts/utils";
import { formulaColor, paymentMethod, phoneType } from "./parsing_from_ur";

export function translateWeekday(wd: joda.DayOfWeek): string {
  switch (wd.ordinal()) {
    case 0:
      return "Maandag";
    case 1:
      return "Dinsdag";
    case 2:
      return "Woensdag";
    case 3:
      return "Donderdag";
    case 4:
      return "Vrijdag";
    case 5:
      return "Zaterdag";
    case 6:
      return "Zondag";
    default:
      return "";
  }
}

export const showWeekday = translateWeekday;

export function translateMonth(m: joda.Month): string {
  switch (m.ordinal()) {
    case 0:
      return "Januari";
    case 1:
      return "Februari";
    case 2:
      return "Maart";
    case 3:
      return "April";
    case 4:
      return "Mei";
    case 5:
      return "Juni";
    case 6:
      return "Juli";
    case 7:
      return "Augustus";
    case 8:
      return "September";
    case 9:
      return "Oktober";
    case 10:
      return "November";
    case 11:
      return "December";
    default:
      return "";
  }
}

export function describePeriod(
  firstday: joda.LocalDate,
  lastday: joda.LocalDate,
): string {
  if (firstday.year() === lastday.year()) {
    return (
      translateMonth(firstday.month()).substring(0, 3) +
      " - " +
      translateMonth(lastday.month()).substring(0, 3) +
      " " +
      firstday.year().toString()
    );
  } else {
    return firstday.year().toString() + " - " + lastday.year().toString();
  }
}

export const renderPeriod = describePeriod;

export function translatePhoneType(ph: phoneType): string {
  switch (ph) {
    case "Phone":
      return "Telefoon";
    case "CellPhone":
      return "GSM";
    case "Mother":
      return "GSM Moeder";
    case "Father":
      return "GSM Vader";
    default:
      return checkAllCasesHandled(ph);
  }
}

export function translateFormulaColor(m: formulaColor): string {
  switch (m) {
    case "Pink":
      return "Roos";
    case "Purple":
      return "Paars";
    case "Green":
      return "Groen";
    case "Red":
      return "Rood";
    case "Orange":
      return "Oranje";
    default:
      return checkAllCasesHandled(m);
  }
}
export const showFormulaColor = translateFormulaColor;

export function renderPaymentMethod(m: paymentMethod): string {
  switch (m) {
    case "Cash":
      return "Cash";
    case "Bancontact":
      return "Bancontact";
    case "VISA":
      return "VISA";
    case "Mastercard":
      return "Mastercard";
    case "Giftcard":
      return "Cadeaubon";
    case "Wire":
      return "Overschrijving";
    case "AccountingSoftware":
      return "Vanuit boekhoudpakket";
    case "Online":
      return "Online";
    case "DirectDebit":
      return "Incasso";
    case "Chargeback":
      return "Terugstorting via Mollie";
    case "Refund":
      return "Terugstorting via Mollie";
    default:
      return checkAllCasesHandled(m);
  }
}
